<template>
  <v-card>
    <v-card-title>Redeem Information</v-card-title>
    <v-card-text
      ><v-container>
        <v-row>
          <v-col sm="12" md="12" xs="12" lg="12"
            ><v-text-field
              readonly="readonly"
              v-model="redeemInfo.status"
              label="Status"
            ></v-text-field></v-col
        ></v-row>
        <v-row>
          <v-col sm="12" md="12" xs="12" lg="12"><v-img :src="image"></v-img></v-col
        ></v-row>
        <v-row>
          <v-col sm="12" md="12" xs="12" lg="12"
            ><v-text-field
              readonly="readonly"
              v-model="redeemInfo.rewardId.name"
              label="ของรางวัล"
            ></v-text-field></v-col
        ></v-row>
        <v-row>
          <v-col sm="12" md="12" xs="12" lg="12"
            ><v-text-field
              readonly="readonly"
              v-model="redeemInfo.rewardId.value"
              label="มูลค่า"
            ></v-text-field></v-col
        ></v-row>
        <v-row>
          <v-col sm="12" md="12" xs="12" lg="12"
            ><v-text-field
              readonly="readonly"
              v-model="redeemInfo.rewardId.point"
              label="คะแนน"
            ></v-text-field></v-col
        ></v-row>
        <v-row>
          <v-col sm="12" md="12" xs="12" lg="12"
            ><v-text-field
              readonly="readonly"
              v-model="memberName"
              label="สมาชิก"
            ></v-text-field></v-col></v-row
      ></v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn
        class="primary"
        @click="update('Approved')"
        :disabled="redeemInfo.status != 'Pending'"
        >อนุมัต</v-btn
      >
      <v-btn
        class="warning"
        @click="update('Rejected')"
        :disabled="redeemInfo.status != 'Pending'"
        >ปฏิเสธ</v-btn
      >
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  props: {
    redeemInfo: {
      type: Object,
    },
  },
  name: "RedeemInfo",
  data() {
    return {
      image:
        process.env.VUE_APP_LOYALTY_API_URI +
          "/public/" +
          this.redeemInfo.rewardId.image || "",
    };
  },
  computed: {
    memberName() {
      return this.redeemInfo.memberId.firstname + " " + this.redeemInfo.memberId.lastname;
    },
  },
  methods: {
    update(status) {
      console.log(status);
      let payload = {
        status: status,
        updatedBy: sessionStorage.getItem("email"),
        custId: sessionStorage.getItem("custId"),
        apiKey: sessionStorage.getItem("apiKey"),
      };
      this.$emit("updateRedeem", payload);
      //let response = await this.$store.dispatch("updatePendingRedeem", payload);
      //console.log(response);
    },
  },
  mounted() {
    console.log(this.redeemInfo);
    console.log(this);
  },
};
</script>
